const REASON_KEYS = [
  "ineligibleReason",
  "ineligibilityReason",
  "inelegibilityReason",
  "motivoInelegibilidade",
  "motivo_inelegibilidade",
  "ineligible_reason",
  "eligibilityReason",
];

function firstText(...values) {
  return values.find((value) => typeof value === "string" && value.trim())?.trim() || "";
}

export function itemIneligibilityReason(item) {
  if (!item || typeof item !== "object") {
    return "";
  }
  const nested = item.eligibility && typeof item.eligibility === "object" ? item.eligibility : {};
  const flagged = item.eligible === false
    || item.elegivel === false
    || item.isEligible === false
    || item.ineligible === true
    || item.inelegivel === true
    || nested.eligible === false;
  const named = firstText(
    ...REASON_KEYS.map((key) => item[key]),
    nested.reason,
    nested.motivo,
    nested.message,
  );
  if (named) {
    return named;
  }
  if (!flagged) {
    return "";
  }
  return firstText(item.reason, item.motivo, item.message)
    || "Este item não está elegível para troca ou devolução.";
}
